import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Hero from './components/Hero';
import Features from './components/Features';
import Process from './components/Process';
import Mission from './components/Mission';
import AboutUs from './components/AboutUs';
import Testimonials from './components/Testimonials';
import SignUp from './components/SignUp';
import Footer from './components/Footer';
import RateYourRoast from './pages/RateYourRoast';
import RoastSelection from './pages/RoastSelection';
import CustomBranding from './pages/CustomBranding';
import CustomBrandingExample from './pages/CustomBrandingExample';
import HeaderHoliday from './pages/HeaderHoliday';
import GiftCertificates from './pages/GiftCertificates';
import WakeWithDrake from './pages/WakeWithDrake';
import RegimentRoast from './pages/RegimentRoast';
import FestivalBlend from './pages/FestivalBlend';
import LocalNoon from './pages/LocalNoon';
import LocalNoonRoast from './pages/LocalNoonRoast';
import KiltedAndCaffeinated from './pages/KiltedAndCaffeinated';
import HammerFist from './pages/HammerFist';
import BonusBatch from './pages/BonusBatch';
import MFFImpact from './pages/MFFImpact';
import CoffeeProject from './pages/CoffeeProject';
import CoffeeAdmin from './pages/CoffeeAdmin';
import CoffeeLab from './pages/CoffeeLab';
import CoffeeLabBook from './pages/CoffeeLabBook';
import AmeliaPaysonHouse from './pages/AmeliaPaysonHouse';
import YourIslandConnection from './pages/YourIslandConnection';
import Redds from './pages/Redds';
import BringVsDontBring from './pages/BringVsDontBring';
import AllegedlyLanded from './pages/AllegedlyLanded';
import BondSessions from './pages/BondSessions';

const HomePage = () => (
  <div className="min-h-screen bg-[#132947]">
    <Header />
    <Hero />
    <Features />
    <Process />
    <Mission />
    <AboutUs />
    <Testimonials />
    <SignUp />
    <Footer />
  </div>
);

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/rateyouroast" element={<RoastSelection />} />
        <Route path="/rateyouroast/:roastId" element={<RateYourRoast />} />
        <Route path="/custom-branding" element={<CustomBranding />} />
        <Route path="/custom-branding/example" element={<CustomBrandingExample />} />
        <Route path="/header-holiday" element={<HeaderHoliday />} />
        <Route path="/gift-certificates" element={<GiftCertificates />} />
        <Route path="/regiment-roast" element={<RegimentRoast />} />
        <Route path="/wake-with-drake" element={<WakeWithDrake />} />
        <Route path="/festival-blend" element={<FestivalBlend />} />
        <Route path="/local-noon" element={<LocalNoon />} />
        <Route path="/local-noon-roast" element={<LocalNoon />} />
        <Route path="/kilted-and-caffeinated" element={<KiltedAndCaffeinated />} />
        <Route path="/hammer-fist" element={<HammerFist />} />
        <Route path="/bonus-batch" element={<BonusBatch />} />
        <Route path="/mff-impact" element={<MFFImpact />} />
        <Route path="/coffee" element={<CoffeeProject />} />
        <Route path="/coffee-admin" element={<CoffeeAdmin />} />
        <Route path="/coffee-lab" element={<CoffeeLab />} />
        <Route path="/coffee-lab/book" element={<CoffeeLabBook />} />
        <Route path="/amelia-payson-house" element={<AmeliaPaysonHouse />} />
        <Route path="/your-island-connection" element={<YourIslandConnection />} />
        <Route path="/redds" element={<Redds />} />
        <Route path="/bring-vs-dont-bring" element={<BringVsDontBring />} />
        <Route path="/allegedly-landed" element={<AllegedlyLanded />} />
        <Route path="/sessions" element={<BondSessions />} />
      </Routes>
    </Router>
  );
}

export default App;